import React from "react";
import Navbar from "../Utils/NavBar";
import { FaYoutube } from "react-icons/fa";
require("../../assets/stylesheets/Tutorials/Tutorials.css");

function Tutorial({ title, code }) {
  return (
    <div className="tutorial">
      <div className="tutorialHeader">{title}</div>
      <div className="tutorialContent">
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${code}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="optionsBar">
        <a href={`https://youtu.be/${code}`} target="_blank">
          <div className="btnYoutube">
            Ver en <FaYoutube className="youtube" />
          </div>
        </a>
      </div>
    </div>
  );
}

function TutorialSection() {
  return (
    <div className="inSection">
      <Tutorial title="¿Cómo inscribir mi proyecto?" code="hKhH2dEakc4" />
      <Tutorial title="¿Cómo apoyar un proyecto?" code="UCAIFRhaGKk" />
    </div>
  );
}

function Tutorials() {
  return (
    <div className="Tutorials">
      <Navbar />
      <h1>Tutoriales</h1>
      <TutorialSection />
    </div>
  );
}

export default Tutorials;
